$(document).ready(function () {
  var $upsellSlider = $(".upsell_slider");
  var $prevArrow = $(".upsell_prev");
  var $nextArrow = $(".upsell_next");
  var upsellHeader = $(".upsell_header");
  var numChildren = $upsellSlider.children().length;

  upsellHeader.toggle(numChildren !== 0);

  if (numChildren > 1) {
    $upsellSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      autoplay: true,
      prevArrow: $prevArrow,
      nextArrow: $nextArrow,
      autoplaySpeed: 7000,
      dots: true,
    });
  } else {
    $prevArrow.add($nextArrow).hide();
  }
});
